import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import { List } from 'react-virtualized';
class ChainFilter extends Component {
    state = {
        chainList:[],
        chainValue: null,
        isChainLoading: true
    };
    componentDidMount(){
        if(this.props.object_type==='Innoviti' && this.props.user_type ==='Internal') {
            this.getChain(this.props.object_code, 'innoviti', this.props.object_type, this.props.object_code);
        } else if(this.props.object_type==='Merchant'){
            this.getChain(this.props.object_code, 'merchant', this.props.object_type, this.props.object_code);
        } else if(this.props.object_type==='Chain'){
            var chainData = [];
            this.props.object_code.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
        }
        else if(this.props.object_type==='Store'){

        }

    }
    restChainFilter() {
        this.setState({
            chainValue: [],
        })
    }
    getChain(code, type, object_type, object_code){
        this.setState({
            chainList:[],
            isChainLoading: true,
            chainValue:[]
        })
        axios.post(config.get('API_URL')+'/reports/get-all-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                isChainLoading: false
            })
        });
    }

    changeChain(login_type, optionSelected){
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (this.props.object_type != 'Chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }

        this.props.onSelectChain(optionSelected, cidArray);
        this.setState({
            chainValue:optionSelected,
        });

    }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        return (
            <ReactMultiSelectCheckboxes name="merchants"
                isMulti
                components={{ MenuList }}
                value={this.state.chainValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeChain.bind(this,'')}
                options={this.state.chainList}
                placeholderButtonLabel="Select [Chain]"
                isLoading={this.state.isChainLoading}
            />
        );

    }
}
export default ChainFilter;